module.exports = __webpack_public_path__ + "static/avatar.3c2a45bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/avatar.jpg
// module id = 598
// module chunks = 107818501498521